(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-utils/string-format/assets/name-case.js') >= 0) return;  svs.modules.push('/components/tb-utils/string-format/assets/name-case.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';
let logger;
if (isServer) {
  const trinidad = require('trinidad-core').core;
  logger = trinidad.logger('component:string-format:name-case');
} else {
  logger = svs.components.tbUtils.stringFormat.logger;
}

const nameCase = name => {
  name = name.toLowerCase(); 
  try {
    return name.split(/([ :–—-])/).map(current => {
      if (current.search(/^(von|af|al|bin|de|del|du|da|el|van|la|di|le)$/i) > -1) {
        return current;
      }
      if (/^mc[a-z]/.test(current)) {
        return current.charAt(0).toUpperCase() + current.charAt(1) + current.charAt(2).toUpperCase() + current.slice(3);
      }
      return current.charAt(0).toUpperCase() + current.slice(1);
    }).join('');
  } catch (e) {
    logger.info('Error in nameCase', e, name);
    return name;
  }
};
const exportedFunctions = {
  nameCase
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.components.tbUtils.stringFormat = _objectSpread(_objectSpread({}, svs.components.tbUtils.stringFormat), exportedFunctions);
}

 })(window);